import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.333 12a.96.96 0 0 1-.708-.292.96.96 0 0 1-.292-.708q0-.417.292-.708A.97.97 0 0 1 2.333 10h.334V4q0-.55.391-.942.392-.39.942-.391h9.333q.285 0 .475.191a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192H4v6h3q.417 0 .708.292Q8 10.583 8 11a.96.96 0 0 1-.292.708A.96.96 0 0 1 7 12zM10 13.333a.65.65 0 0 1-.475-.191.65.65 0 0 1-.192-.475V6q0-.283.192-.475A.65.65 0 0 1 10 5.333h4q.283 0 .475.192a.65.65 0 0 1 .192.475v6.667a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191zm.667-2h2.666V6.667h-2.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })